import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class ItemServices {
  async item_to_pay(ids: number[], currency_to_convert: number, exchange_updated: []): Promise<any[]> {
    try {
      let array: string[] = []
      ids.forEach((id) => {
        array.push(`&reservation_id=${id}`)
      })
      const filterstostring = array.join('')

      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment/?${filterstostring}`,
        exchange_updated,
        {
          headers: { 'authentication-token': getJWT()! },
          params: {
            operator: 'or_equal',
            ordering: 'id.ASC',
            currency_to_convert: currency_to_convert,
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async cancel_item(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/cancel/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async cancel_segment_from_item(hash: string, id: number): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/train-detail/refund/?hash_item=${hash}&train_detail_segment_id=${id}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async delete_segment_from_item(hash: string, id: number): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/train-detail/${hash}/item/${id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async emit_item(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/issuance/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async approve_fraud_item(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/accept-revision/hash-item/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async refuse_fraud_item(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/reject-revision/hash-item/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async approve_debin_payment(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/accept-revision/hash-item/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async refuse_debin_payment(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/reject-revision/hash-item/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async retrieve_item(hash: string): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/item/retrieve/hash-item/${hash}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }


  async refresh_hotel_detail(hash: string): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/hotel-detail/hash/${hash}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async add_tags_in_item(item_id: number, list_tags_ids: number[]): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/tag/${item_id}`,
        list_tags_ids,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_status_item(status: string, hash_item: string): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/status/${status}/${hash_item}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async emit_status_item(hash_item: string): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/status_invoice/${hash_item}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async cancel_status_item(hash_item: string): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/status_cancel/${hash_item}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_payment_status_item(payment_status: string, hash_item: string): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment_status/${payment_status}/${hash_item}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_billing_status_item(status: string, hash_item: string): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/billing/hash-item/${hash_item}/situation/${status}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_payment_status_guaranteed(hash_item: string): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment_status_guaranteed/${hash_item}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_item(item_id: string, body: object): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/item/${item_id}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_item_and_detail(item_id: string, body: object): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/item/item-detail/`, body, {
        params: { item_id: item_id },
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async refund_train_segment(hash_item: string): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/train-detail/refund/confirm/`,
        [],
        {
          params: { hash_item },
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async get_cost_to_refund_train_segment(hash_item: string, train_detail_segment_id: number): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/train-detail/refund/create/`,
        [],
        {
          params: { hash_item, train_detail_segment_id },
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async move_item(
    hash_item: string,
    to_reservation_number: number,
    current_rsv_number: string
  ): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/move/reservation_number/`,
        [],
        {
          params: { hash_item, to_reservation_number, current_rsv_number },
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async split_passenger(
    hash_item: any,
    ids_passenger: number[]
  ): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/split/`,
        { hash_item, pax_id: ids_passenger },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async get_billing_status(hash_item: string, from_cache = true): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/item/facturacion/invoice/${hash_item}`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: {
            from_cache
          }
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async clone_item(hash_item: string): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/clone/${hash_item}`,
        { hash_item },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async clone_item_online(hash_item: string): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/after-sales/${hash_item}`,
        { hash_item },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async register_return(hash_item: string): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/register-return/${hash_item}`,
        { hash_item },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async void_item(hash: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item/void/hash-item/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_due_date(hash_item: string, due_date_new: string): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/update-due-date/${hash_item}/${due_date_new}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generate_order(body: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment-order/provider/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generate_client_order(body: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment-order/client/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deletePaymentOrder(id: number): Promise<any[]> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment-order/${id}`
        ,
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editHotelCodes(id: number, body: any): Promise<any[]> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/hotel-detail/${id}`,
        body
        ,
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editTransferCode(id: number, body:any): Promise<any[]> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/transfer-detail/${id}`,
          body
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editOtherCodes(id: number, body: any): Promise<any[]> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/other-detail/${id}`,
        body
        ,
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getItemStatusOptions(itemType: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/${itemType}/status/`
        ,
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateItemsToDelete(hash_item: any): Promise<any[]> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/item/facturacion/erp-system/`
        ,
        {
          data: hash_item,
          headers: {
            'Content-Type': 'multipart/form-data',
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async disableRebooker(hash_item: string): Promise<any[]> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/hotel-detail/disable-rebooker/${hash_item}`
        ,
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateErpId(id: number, erp_system_id: number): Promise<any[]> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/facturacion/update-id/`
        ,
        { id, erp_system_id },
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateRecord(hash: string): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/payment/hash_item/${hash}`
        ,
        {},
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateAutoncancelDate(cancel_date_id: number, cancel_date: string): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/cancel-info/autocancel_date/`
        ,
        {},
        {
          params: {
            cancel_date_id,
            cancel_date
          },
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateAutoncancelDateItem(item_id: number, cancel_date: string): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item/autocancel_date/`
        ,
        {},
        {
          params: {
            item_id,
            cancel_date
          },
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createAftersalesItem(hash_item: string): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/after-sales/new-reservation/${hash_item}`
        ,
        {},
        {
          headers: {
            'authentication-token': getJWT()!
          },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async complementaryItem(
    hash_item: any,
    body: object
  ): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/complementary/${hash_item}`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

}




export const itemServices = new ItemServices()
